import React from 'react'

import './CardActions.css'

const CardActions = ({children}) => (
  <div className="card-header-actions">
    {children}
  </div>
)

export default CardActions



// WEBPACK FOOTER //
// ./src/components/ui/CardActions/index.jsx